import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatchType } from 'app/store/types';

const createAppAsyncThunk = createAsyncThunk; // Since JavaScript doesn't have types, directly assign createAsyncThunk

export default createAppAsyncThunk;
